module.exports = __webpack_public_path__ + "img/logo.bcc55ee9.svg";